import { useState } from "react";
import { gql, useQuery, useMutation } from "@apollo/client";
import { captureException } from "@sentry/react";

import LoadingBox from "components/other/LoadingBox";
import BoxLoadingSpinner from "components/other/BoxLoadingSpinner";
import PageTemplateList from "./PageTemplateList";
import { PAGES_DOMAIN_URL } from "constants";

export default () => {
  const [page, setPage] = useState(1);
  const [categorySelectionOpened, setCategorySelectionOpened] = useState(false);
  const [categorySelected, setCategorySelected] = useState("all");

  const limit = 10;

  // Fetch data
  const GET_PAGE_TEMPLATES_LIST_DATA = gql`
    query GetPageTemplateListData(
      $category: String
      $page: Int!
      $limit: Int!
    ) {
      pageTemplateListData(category: $category, page: $page, limit: $limit) {
        pages_templates {
          id
          name
          category
        }
        numOfResults
      }
    }
  `;

  const { loading, data, error } = useQuery(GET_PAGE_TEMPLATES_LIST_DATA, {
    variables: {
      category: categorySelected,
      page,
      limit,
    },
    fetchPolicy: "network-only",
  });

  if (error) {
    console.log("error fetching page list data", error);
    captureException(error);
  }

  // handle Category selection
  const toggleCategoryForm = () => {
    setCategorySelectionOpened((prevState) => !prevState);
  };

  const onCategorySelect = (category) => {
    setCategorySelected(category);
    setCategorySelectionOpened(false);
  };

  // handle open template
  const CREATE_EDITOR_LOGIN_CODE = gql`
    mutation CreateEditorLoginCode {
      createEditorLoginCode {
        resultCode
        code
      }
    }
  `;

  const [createEditorLoginCode] = useMutation(CREATE_EDITOR_LOGIN_CODE);

  const onOpenClick = async (id) => {
    const result = await createEditorLoginCode({});
    console.log("result", result);

    window
      .open(
        `${PAGES_DOMAIN_URL}/editor-login?code=${result.data.createEditorLoginCode.code}&template=${id}`,
        "_blank"
      )
      .focus();
  };

  console.log("data", data);

  return (
    <>
      {!data && (
        <LoadingBox>
          <BoxLoadingSpinner height="435px" />
        </LoadingBox>
      )}
      {data && (
        <PageTemplateList
          data={data}
          categorySelectionOpened={categorySelectionOpened}
          toggleCategoryForm={toggleCategoryForm}
          categorySelected={categorySelected}
          onCategorySelect={onCategorySelect}
          onOpenClick={onOpenClick}
        />
      )}
    </>
  );
};
